import { render, staticRenderFns } from "./ClientPickerTransmiter.vue?vue&type=template&id=0bbddff8"
import script from "./ClientPickerTransmiter.vue?vue&type=script&lang=js"
export * from "./ClientPickerTransmiter.vue?vue&type=script&lang=js"
import style0 from "./ClientPickerTransmiter.vue?vue&type=style&index=0&id=0bbddff8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports